<template>
  <el-row :gutter="20" v-loading="loading">
    <el-col :span="11">
      <el-card>
        <div class="f-right border-b">
          <div class="flex1">菜单名称</div>
          <!-- <el-button icon="el-icon-plus" type="primary" @click="add">增加</el-button> -->
        </div>
        <el-table :data="list" class="">
          <el-table-column type="index" label="序号" align="center">
          </el-table-column>
          <el-table-column prop="c_name" label="单位名称" align="center">
          </el-table-column>

          <el-table-column label="操作" align="center" width="160px">
            <template slot-scope="scope">
              <el-button size="mini" type="success" @click="edit(scope.row)"
                >修改</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          background
          class="mt20 tx-center"
          @current-change="pageChange"
          :current-page.sync="params.page"
          :page-size="10"
          layout="prev, pager, next, jumper"
          :total="count"
        >
        </el-pagination>
      </el-card>
    </el-col>
    <el-col :span="13">
      <el-card>
        <div>
          <h3 class="blue">设备物联列表</h3>
          <el-form
            :model="form"
            label-width="100px"
            ref="form"
            class="mt20"
            label-position="right"
            :rules="rules"
          >
            <h2>{{ form.c_name }}</h2>
            <!-- <el-form-item class="mt20" label="选择菜单:" prop="">
                            <el-select v-model="form">
                                <el-option v-for="item in unitList" :key="item.mc_id" :label="item.mc_name" :value="item.mc_id"></el-option>
                            </el-select>
                        </el-form-item> -->
            <div class="pd15">菜单列表：</div>
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="allCheck"
              @change="handleCheckAllChange"
              style="margin-bottom: 10px"
              >全选</el-checkbox
            >
            <div>
              <el-form-item
                label-width="0"
                v-for="(item, index) in tree"
                :key="index"
              >
                <div class="flex">
                  <div style="margin-right: 30px">
                    <el-checkbox-group v-model="form.menu">
                      <el-checkbox
                        :label="item.tr_role_key"
                        name="menu"
                        :checked="false"
                        >{{ item.tr_role_name }}</el-checkbox
                      >
                    </el-checkbox-group>
                  </div>
                </div>
              </el-form-item>
            </div>

            <div class="center">
              <el-button
                type="primary"
                @click="formSubmit"
                size="small"
                :loading="loading1"
                >确定</el-button
              >
            </div>
          </el-form>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { getMenu } from "../../api/menu";
import { getUnit } from "../../api/common";
export default {
  data() {
    return {
      allCheck: false,
      isIndeterminate: false,
      status: 1,
      list: [],
      loading: false,
      loading1: false,
      params: {
        page: 1,
      },
      form: {
        c_name: "",
        c_company_num: "",
        menu: [], //菜单key
      },

      rules: {
        c_name: { required: true, message: "请选择单位", trigger: "blur" },
      },
      count: 0,
      tree: [],
      unitList: [],
    };
  },
  created() {
    this.getList();
    // getMenu().then(res => {
    //     let data = res.data
    //     data.forEach(it=>{
    //         if(it.son.length){
    //             this.tree.push(...it.son)
    //         }
    //     })
    //     this.tree.forEach(it=>{
    //         this.menus.push(it.tr_power_key)
    //         it.son.forEach(im=>{
    //             this.funcs.push(im.tr_power_key)
    //         })
    //     })
    // })
    // getUnit(1).then(res=>{
    //     this.unitList = res.data
    // })
  },
  methods: {
    handleCheckAllChange(val) {
      var arr = [];
      this.tree.map((item, index) => {
        arr.push(item.tr_role_key);
      });
      this.form.menu = val ? arr : [];
      this.isIndeterminate = false;
    },
    getList() {
      this.$post("devicemanage/selectconpanybyme")
        .then((res) => {
          this.count = res.data.count;
          this.list = res.data;
          this.loading = 0;
        })
        .catch((err) => {
          this.loading = 0;
        });
      this.$post("/devicemanage/menulist").then((res) => {
        this.tree = res.data;
      });
      //     getPower(this.params).then(res=>{
      //         var arr = res.data.list
      //         var arr2=[]
      //         arr.map((item,index)=>{
      //             arr2.push({tr_power_key:item.tr_power_key,tr_power_name:item.tr_power_name})
      //         })
      //         this.tree=arr2
      //     })
      //    this.$mpList(1).then(res=>{
      //        this.unitList = res.data
      //    })
    },
    pageChange(page) {
      this.params.page = page;
      this.getList();
    },
    add() {
      this.status = 1;
      this.reset();
    },
    edit(it) {
      this.reset();
      this.form.c_company_num = it.c_company_num;
      this.form.c_name = it.c_name;
      this.$post(`/devicemanage/menukey/${this.form.c_company_num}`).then(
        (res) => {
          console.log(res);
          this.form = { ...this.form, ...res.data };
          var arr = [];
          if (this.form.menu.length) {
            this.form.menu.split(",").map((item) => {
              arr.push(Number(item));
            });
          }
          this.form.menu = arr;
        }
      );
    },
    del(it) {
      del({ tr_role_key: it.tr_role_key }).then((res) => {
        // this.$message.success("删除成功");
        this.$message({
									message: '删除成功',
									type: 'success',
									duration: 700,
								});
        this.getList();
      });
    },
    formSubmit() {
      if (this.form.c_name) {
        console.log(this.form);
        this.$post("/devicemanage/menuadd", this.form).then((res) => {
          console.log(res);
          // this.$message.success("操作成功");
          this.$message({
									message: '操作成功',
									type: 'success',
									duration: 700,
								});
          this.reset();
        });
      } else {
        this.$message.warning("请选择单位");
        return false;
      }
    },
    reset() {
      this.form.c_name = "";
      this.form.menu = [];
      this.form.c_company_num = "";
      this.allCheck = false;
      this.isIndeterminate = false;
    },
  },
};
</script>

<style scoped>
.el-checkbox {
  display: inline-block;
}
.pd15 {
  padding: 15px 0;
}
</style>
